export default __webpack_public_path__ + "static/media/Chrome Mobile.cb9e2605.svg";